export default "__VITE_ASSET__ldfM70Ss__"